import { useEffect, useState } from 'react';

import {
  ChargeCode as gqlChargeCode,
  SortDirection as gqlSortDirection,
  GroupType as gqlGroupType,
} from 'graphql-query-contracts';

import { chargeCodeFilterQuery } from 'graphql-queries';
import { convertTo62, convertToUUID } from 'uuid-encoding';

import * as Sentry from '@sentry/browser';
import { getClient } from 'lane-shared/apollo';
import { useApolloClient } from '@apollo/client';

type ApolloClient = ReturnType<typeof getClient>;
type ChargeCodeOption = {
  label: string;
  value: string;
};

export function useChargeCodesOptions(channelId: string | undefined) {
  const apolloClient = useApolloClient();
  const [chargeCodes, setChargeCodes] = useState<ChargeCodeOption[]>([]);

  useEffect(() => {
    if (channelId) {
      fetchChargeCodesForFilters(channelId, apolloClient)
        .then(data => {
          const chargeCodeOptions = data.map(chargeCode => ({
            label: chargeCode.chargeCode,
            value: convertTo62(chargeCode.id),
          }));

          setChargeCodes(chargeCodeOptions);
        })
        .catch(error => {
          Sentry.captureException('BPError - chargeCodeFilterQuery error', {
            contexts: {
              fetchChargeCode: {
                channelId,
                error,
              },
            },
          });
        });
    }
  }, [channelId]);

  return chargeCodes;
}

async function fetchChargeCodesForFilters(
  channelId: string,
  apolloClient: ApolloClient
) {
  const { data } = await apolloClient.query({
    query: chargeCodeFilterQuery,
    variables: {
      listChargeCodeRequest: {
        groupId: convertToUUID(channelId),
        groupType: gqlGroupType.GroupTypeActivateChannel,
        pagination: {
          perPage: 200,
          start: 0,
        },
        sortBy: {
          dir: gqlSortDirection.Asc,
          key: 'charge_code',
        },
      },
    },
    fetchPolicy: 'network-only',
  });

  if (data) {
    const chargeCodes = data.accounts?.listChargeCode?.chargeCodes || [];
    const validChargeCodes: gqlChargeCode[] = chargeCodes.filter(
      (chargeCode: any): chargeCode is gqlChargeCode => chargeCode !== null
    );

    return validChargeCodes;
  }

  return [];
}
